const closestPlace = [
    {
        id: "Police",
        text: "Police",
        icon: "police"
    },
    {
        id: "Hospital",
        text: "Hospital",
        icon: "hospital"
    },
    {
        id: "Shop",
        text: "Shop",
        icon: "shop"
    },
    {
        id: "Gas Station",
        text: "Gas Station",
        icon: "gas_station"
    },
    {
        id: "School",
        text: "School",
        icon: "school"
    },
    {
        id: "Mall",
        text: "Mall",
        icon: "mall"
    }
];

export default closestPlace;
